var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: true,
        title: _vm.$_.get(_vm.block, "name", _vm.$t("chatbotv2.blockDetails")),
        width: 800,
        footer: null,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _vm.block && !_vm.loading
        ? _c(
            "div",
            { staticClass: "block-details-content" },
            [
              _c("div", { staticClass: "block-header-section" }, [
                _c("span", { staticClass: "material-icons block-icon-large" }, [
                  _vm._v(_vm._s(_vm.block.icon || "extension")),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "header-info" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.block.name))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.block.description)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "meta-tags" },
                    [
                      _c("a-tag", { attrs: { color: "blue" } }, [
                        _vm._v(_vm._s(_vm.block.category)),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.block.tags, function (tag) {
                        return _c("a-tag", { key: tag }, [_vm._v(_vm._s(tag))])
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("a-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "stats-section" }, [
                _c(
                  "div",
                  { staticClass: "stat-item" },
                  [
                    _c("a-icon", { attrs: { type: "download" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.block.usageCount || 0) +
                          " " +
                          _vm._s(_vm.$t("chatbotv2.uses"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stat-item" },
                  [
                    _c("a-icon", {
                      staticStyle: { color: "#faad14" },
                      attrs: { type: "star", theme: "filled" },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.block.averageRating
                            ? _vm.block.averageRating.toFixed(1)
                            : "0.0"
                        ) +
                          " (" +
                          _vm._s(_vm.block.totalRatings || 0) +
                          " " +
                          _vm._s(_vm.$t("chatbotv2.ratings")) +
                          ")"
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("a-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "parameters-section" }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("chatbotv2.parameters")))]),
                _vm._v(" "),
                _vm.block.parameters && _vm.block.parameters.length > 0
                  ? _c(
                      "div",
                      { staticClass: "parameters-list" },
                      _vm._l(_vm.block.parameters, function (param) {
                        return _c(
                          "div",
                          { key: param.name, staticClass: "parameter-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "param-header" },
                              [
                                _c("strong", [_vm._v(_vm._s(param.label))]),
                                _vm._v(" "),
                                _c(
                                  "a-tag",
                                  { attrs: { size: "small", color: "blue" } },
                                  [_vm._v(_vm._s(param.type))]
                                ),
                                _vm._v(" "),
                                param.required
                                  ? _c(
                                      "a-tag",
                                      {
                                        attrs: { size: "small", color: "red" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("chatbotv2.isRequired"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            param.description
                              ? _c("p", { staticClass: "param-description" }, [
                                  _vm._v(_vm._s(param.description)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            param.defaultValue
                              ? _c("p", { staticClass: "param-default" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("auto.blockEditorDefaultLabel")
                                      ) +
                                      " "
                                  ),
                                  _c("code", [
                                    _vm._v(_vm._s(param.defaultValue)),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("p", { staticClass: "no-parameters" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.noParameters"))),
                    ]),
              ]),
              _vm._v(" "),
              _c("a-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "ratings-section" }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("chatbotv2.ratings")))]),
                _vm._v(" "),
                !_vm.userRating
                  ? _c(
                      "div",
                      { staticClass: "add-rating" },
                      [
                        _c("a-rate", {
                          model: {
                            value: _vm.newRating,
                            callback: function ($$v) {
                              _vm.newRating = $$v
                            },
                            expression: "newRating",
                          },
                        }),
                        _vm._v(" "),
                        _c("a-textarea", {
                          attrs: {
                            rows: 3,
                            placeholder: _vm.$t("chatbotv2.writeReview"),
                          },
                          model: {
                            value: _vm.newComment,
                            callback: function ($$v) {
                              _vm.newComment = $$v
                            },
                            expression: "newComment",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              loading: _vm.submittingRating,
                            },
                            on: { click: _vm.submitRating },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("chatbotv2.submitRating")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.ratings.length > 0
                  ? _c(
                      "div",
                      { staticClass: "ratings-list" },
                      _vm._l(_vm.ratings, function (rating) {
                        return _c(
                          "div",
                          { key: rating._id, staticClass: "rating-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "rating-header" },
                              [
                                _c("a-rate", {
                                  attrs: { value: rating.rating, disabled: "" },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "rating-date" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(rating.createdAt))
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            rating.comment
                              ? _c("p", { staticClass: "rating-comment" }, [
                                  _vm._v(_vm._s(rating.comment)),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("p", { staticClass: "no-ratings" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.noRatings"))),
                    ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.close")))]
                  ),
                  _vm._v(" "),
                  !_vm.isImported
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", loading: _vm.importing },
                          on: { click: _vm.handleImport },
                        },
                        [
                          _c("a-icon", { attrs: { type: "download" } }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("chatbotv2.import")) +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _c("a-tag", { attrs: { color: "green" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("chatbotv2.imported")) +
                            "\n            "
                        ),
                      ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "loading-container" },
            [_c("a-spin", { attrs: { size: "large" } })],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }